import { alpha } from '@mui/material';
const useTableStyles = () => {
    return {
        tableContainer: {
            overflowX: 'auto',
            border: 'none',
            borderRadius: 0,
            '& .MuiTable-root': {
                borderCollapse: 'separate',
                borderSpacing: 0
            }
        },
        /* ---------- HEADER ---------- */
        headerRow: {
            backgroundColor: (theme) => theme.palette.grey[200],
            '& .MuiTableCell-root': {
                backdropFilter: 'blur(40px)',
                padding: (theme) => theme.spacing(2),
                fontSize: '14px',
                fontWeight: 500,
                color: (theme) => theme.palette.tertiary[30],
                '&:first-of-type': {
                    borderTopLeftRadius: 16,
                    borderBottomLeftRadius: 16
                },
                '&:last-of-type': {
                    borderTopRightRadius: 16,
                    borderBottomRightRadius: 16
                }
            }
        },
        firstHeadCell: {
            fontWeight: 600,
            color: (theme) => theme.palette.tertiary[30],
            backgroundColor: (theme) => theme.palette.grey[200],
            backdropFilter: 'blur(40px)',
            padding: (theme) => theme.spacing(2),
            borderTopLeftRadius: 16,
            borderBottomLeftRadius: 16
        },
        headCell: {
            fontWeight: 500,
            color: (theme) => theme.palette.tertiary[30],
            backdropFilter: 'blur(40px)',
            padding: (theme) => theme.spacing(2)
        },
        /* ---------- BODY ---------- */
        bodyRow: {
            backgroundColor: '#FFFFFF',
            '& .MuiTableCell-root': {
                padding: (theme) => theme.spacing(2),
                color: (theme) => theme.palette.text.primary,
                fontWeight: 400,
                borderBottom: '1px solid transparent',
                transition: 'all 0.2s ease-in-out'
            },
            '&:last-child .MuiTableCell-root': {
                borderBottom: 'none',
                '&:first-of-type': {
                    borderBottomLeftRadius: 16
                },
                '&:last-of-type': {
                    borderBottomRightRadius: 16
                }
            }
        },
        moduleCell: {
            fontWeight: 500,
            color: (theme) => theme.palette.text.primary
        },
        switchCell: {
            '& .MuiSwitch-root': {
                '& .MuiSwitch-switchBase': {
                    color: '#C4CDD5',
                    '&.Mui-checked': {
                        color: '#3192D0',
                        '& + .MuiSwitch-track': {
                            backgroundColor: '#3192D0',
                        }
                    },
                    '&.Mui-disabled': {
                        color: '#3192D0',
                        '& + .MuiSwitch-track': {
                            backgroundColor: '#3192D0',
                            opacity: 0.5
                        }
                    }
                },
                '& .MuiSwitch-track': {
                    backgroundColor: alpha('#C4CDD5', 0.3)
                }
            }
        }
    };
};
export default useTableStyles;
